// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1__fc99bec993615cf63a0e","cls2":"MultiPaperModal-cls2___bbb32906e7e9bb19ed1 MultiPaperModal-cls1__fc99bec993615cf63a0e"};